import React, { useState, useEffect, useRef } from "react";
import OracleInput from "./OracleInput";
import OraclePanel from "./OraclePanel";
import OracleTitle from "./OracleTitle";
import OracleSubTitle from "./OracleSubTitle";
import OracleTokenPanel from "./OracleTokenPanel";
import OracleInputPanel from "./OracleInputPanel";
import OracleInputCurrency from "./OracleInputCurrency";
import OracleInputSymbol from "./OracleInputSymbol";
import OracleButton from "./OracleButton";
import OracleCurrencySelectorPanel from "./OracleCurrencySelectorPanel";
import OracleResult from "./OracleResult";
import CurrencyLogo from "./CurrencyLogo"

import { useOnClickOutside } from "../hooks/rendering";

import { IMAGES_FOLDER, floatPlaceholder, integerPlaceholder } from "../config"


function Oracle(props) {

	const stateMessages = [
		"Choose a token",
		"Set parameters",
		"Connect to web3!"
	]

	const ORACLE_FINAL_STATE = "gm"

	const [oracleTokenIn, setOracleTokenIn] = useState();
	const [oracleTokenOut, setOracleTokenOut] = useState();
	const [inCurrencySelectorMessage, setInCurrencySelectorMessage] = useState("All");
	const [outCurrencySelectorMessage, setOutCurrencySelectorMessage] = useState("All");
	const [oracleLookbackInRound, setOracleLookbackInRound] = useState();
	const [oracleLookbackInSec, setOracleLookbackInSec] = useState();
	const [currencySelectorSetter, setCurrencySelectorSetter] = useState(() => setOracleTokenOut);
	const [results, setResults] = useState([]);
	const [funnelStateMessage, setFunnelStateMessage] = useState(0);
	const [swapFunnelState, setFunnelState] = useState([
		oracleTokenIn != undefined || oracleTokenOut != undefined,
		false,
		props.isConnectedToWeb3
	])

	useEffect(() => {
		setOracleTokenIn(props.defaultToken)
	}, [props.defaultToken])

	const ref = useRef();
	// State for our modal
	const [showCurrencySelector, setShowCurrencySelector] = useState(false);
	// Call hook passing in the ref and a function to call on outside click
	useOnClickOutside(ref, () => setShowCurrencySelector(false));

	// check ORACLE_STATE_0
	useEffect(() => {
		handleFunnelState(0, oracleTokenIn != undefined || oracleTokenOut != undefined)
	}, [oracleTokenIn, oracleTokenOut]);

	// check ORACLE_STATE_1
	useEffect(() => {
		handleFunnelState(1, oracleLookbackInRound && oracleLookbackInSec)
	}, [oracleLookbackInRound, oracleLookbackInSec]);

	// check ORACLE_STATE_2
	useEffect(() => {
		handleFunnelState(2, props.isConnectedToWeb3)
	}, [props.isConnectedToWeb3]);

	// update Message
	useEffect(() => {
		for (const [k, v] of Object.entries(swapFunnelState)) {
		  if (!v) {
			setFunnelStateMessage(stateMessages[k])
			return
		  }
		}
		setFunnelStateMessage(ORACLE_FINAL_STATE)
		return
	}, [swapFunnelState]);

	const _currencyPanelSelectorSetter = t => {
		setShowCurrencySelector(true)
	}

	function handleFunnelState(name, value) {
		setFunnelState(swapFunnelState => ({...swapFunnelState, [name]: value}))
	}

	function currencyPanelSelectorSetter(setter) {
		return (
			async t => {
				setCurrencySelectorSetter(() => setter)
				_currencyPanelSelectorSetter(false)
			}
		)
	}

	function validateCurrencyAsync(currency) {
		return (
			async t => {
				return	validateCurrency(currency)
			}
		)
	}

	function validateCurrency(currency) {
		return !((oracleTokenIn != undefined && oracleTokenIn == currency) || (oracleTokenOut != undefined && oracleTokenOut == currency))
	}

	function selectCurrency(currency) {
		return (
			async t => {
				if (validateCurrency(currency)) {
					await currencySelectorSetter(currency)
					setShowCurrencySelector(false)
				}
			}
		)
	}

	const updateOracleLookbackInRound = t => {
		if (!isNaN(t.target.value)) {
			setOracleLookbackInRound(t.target.value)
		}
	}

	const updateOracleLookbackInSec = t => {
		if (!isNaN(t.target.value)) {
			setOracleLookbackInSec(parseInt(t.target.value * 3600))
		}
	}

	function handleResult(result, tokenIn, tokenOut) {
		setResults(results => [
			...results, {
				"result": result,
				"tokenIn": tokenIn,
				"tokenOut": tokenOut,
			}
		])
	}

	return(
	<>

		<OraclePanel show={!showCurrencySelector}>

			<OracleTitle>
			 <CurrencyLogo src={require("../" + IMAGES_FOLDER + "brl-logo.png")}/>
			 On-chain Volatility Oracle</OracleTitle>

			<OracleTokenPanel>
			<OracleInputCurrency onClick={currencyPanelSelectorSetter(setOracleTokenOut)} currency={oracleTokenOut} message={inCurrencySelectorMessage} />
			<div style={{verticalAlign: "middle", alignSelf: "center"}}>/</div>
			<OracleInputCurrency onClick={currencyPanelSelectorSetter(setOracleTokenIn)} currency={oracleTokenIn} message={inCurrencySelectorMessage} />
			</OracleTokenPanel>

			<div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
				<span style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
					<OracleSubTitle>Max. # oracle calls</OracleSubTitle>
					<OracleInputPanel>
						<OracleInput onChange={updateOracleLookbackInRound} placeholder={integerPlaceholder} />
					</OracleInputPanel>
				</span>
				<span style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
					<OracleSubTitle>Time window (hours)</OracleSubTitle>
					<OracleInputPanel>
						<OracleInput onChange={updateOracleLookbackInSec} placeholder={floatPlaceholder} />
					</OracleInputPanel>
				</span>
			</div>

			<OracleButton
				web3={props.web3}
				message={funnelStateMessage}
				oracleTokenIn={oracleTokenIn != undefined ? [oracleTokenIn] : props.whitelist}
				oracleTokenOut={oracleTokenOut != undefined ? [oracleTokenOut] : props.whitelist}
				oracleLookbackInRound={oracleLookbackInRound}
				oracleLookbackInSec={oracleLookbackInSec}
				isReadyToOracle={funnelStateMessage == ORACLE_FINAL_STATE} // props.isConnectedToWeb3 &&  (oracleTokenIn != undefined || oracleTokenOut != undefined) && oracleLookbackInRound != undefined && oracleLookbackInSec != undefined}
				resultHandler={handleResult}
				resultReset={() => setResults([])}
				contractAddress={props.contractAddress}
			>
				{funnelStateMessage}
			</ OracleButton>

			<div style={{maxHeight: "20vh", overflow: "scroll"}}>
				{
					results.map(r => {
						return <OracleResult
							tokenIn={r["tokenIn"]}
							tokenOut={r["tokenOut"]}
							mean={r["result"]["mean"]}
							variance={r["result"]["variance"]}
						/>
					})
				}
			</div>

		</OraclePanel>

		<OracleCurrencySelectorPanel
			web3={props.web3}
			account={props.account}
			handleRef={ref}
			validateCurrency={validateCurrency}
			selectCurrency={selectCurrency}
			showCurrencySelector={showCurrencySelector}
			currencies={props.whitelist}
		/>

	</>
	)
}

export default Oracle